import apiStampotheque from './api-stampotheque'
import apiStampyt from './api-stampyt'
import apiAdminVideo from './api-adminVideo'
import apiDeveloper from './api-developer'
import apiUser from './api-user'

export default {
  ...apiStampyt,
  ...apiStampotheque,
  ...apiAdminVideo,
  ...apiDeveloper,
  ...apiUser
}
